import { createElement } from "react";

/**
 * Native <option> elements may only contain text. Build them with a string
 * child so tooling cannot wrap the label in a <span> and trip React's
 * hydration check.
 */
export function selectOption(value, label = value, key = value) {
    const text = label == null || label === "" ? String(value ?? "") : String(label);
    return createElement("option", { key: key ?? text, value: value ?? "" }, text);
}
